module.exports = __webpack_public_path__ + "static/img/animate.23b54b63.svg";